module.exports = __webpack_public_path__ + "static/media/forgotPassword-ill2.d0287627.svg";